module.exports = __webpack_public_path__ + "img/工艺花架-3.7ccf8b96.jpg";